import { CheckCircle, Plus } from "@phosphor-icons/react";
import { QUOTE_TYPES, inr } from "@/lib/dseQuotes";
import DseQuoteActions from "@/components/dse/DseQuoteActions";

export default function DseQuoteResult({ type, quote, onNew }) {
  const cfg = QUOTE_TYPES[type];
  const emi = cfg.emi(quote);
  return (
    <div className="space-y-5" data-testid="dse-quote-result">
      <div className="bg-ink text-white p-5 space-y-4">
        <div className="flex items-center gap-2 text-amber-300 font-mono text-xs tracking-widest">
          <CheckCircle size={16} weight="fill" /> {quote.serial} · {cfg.label.toUpperCase()}
        </div>
        <div>
          <div className="text-sm text-white/70">{quote.vehicle_model}</div>
          <div className="text-xs text-white/50">{quote.customer?.name} · {quote.customer?.phone}</div>
        </div>
        <div>
          <div className="font-mono text-[10px] tracking-[0.2em] text-white/50">ON-ROAD PRICE</div>
          <div className="text-3xl font-bold font-mono" data-testid="dse-result-total">{inr(cfg.total(quote))}</div>
        </div>
        {emi && (
          <div className="grid grid-cols-3 gap-3 border-t border-white/15 pt-4">
            <div>
              <div className="font-mono text-[10px] tracking-widest text-white/50">DOWN PAYMENT</div>
              <div className="font-mono font-semibold" data-testid="dse-result-dp">{inr(emi.total_downpayment)}</div>
            </div>
            <div>
              <div className="font-mono text-[10px] tracking-widest text-white/50">EMI</div>
              <div className="font-mono font-semibold text-amber-300" data-testid="dse-result-emi">{inr(emi.emi)}</div>
            </div>
            <div>
              <div className="font-mono text-[10px] tracking-widest text-white/50">TENURE</div>
              <div className="font-mono font-semibold">{emi.tenure} m</div>
            </div>
          </div>
        )}
      </div>
      <DseQuoteActions type={type} quote={quote} testPrefix="dse-result" />
      <button type="button" onClick={onNew} data-testid="dse-new-quote"
        className="w-full flex items-center justify-center gap-2 py-3 border border-canvas-line text-sm text-ink hover:border-ink transition-colors">
        <Plus size={16} weight="bold" /> New quote
      </button>
    </div>
  );
}
